export class DayData {
  calendar: string;
  date: string;
  employeeId?: number;// No sale en el word
  festive?: string; // si es festivo o no
  festiveDescription?: string; // Descripción en el caso que sea festivo
  locked: string; // Día bloqueado o no
  festiveType?: string;
  workingDay: string;
  imputations: ImputationsData[];

  constructor() {
    this.imputations = [];
  }
}

export class ImputationsData {
  description: string;
  projectId: string; // ID del proyecto.
  activityTypeId: string; // Indica el tipo de actividad.
  comments?: string;
  hours: any; // Horas imputadas de esa tarea.
  imputationId?: number;
  fatherImputationId?: string;
  sapId: string;
  mpwId: string;
  startTime: string;
  endTime: string;
  timeInPerson: string;
  breakTime: any;
  excessOfTime: string;

  constructor() {
    this.hours = 0;
  }
}


export class ProjectData {
  projectId: string;
  activityTypeId: string;
  sapId: string;
  mpwId: string;
  days: WeekDays[];

  constructor() {
    this.days = [];
  }
}

export class WeekDays {
  hours: string;
  comments?: string;
  imputationId?: number;
  calendar: string;
  date: string;
  employeeId?: number;
  festive?: string; // si es festivo o no
  festiveDescription?: string; // Descripción en el caso que sea festivo
  locked: string; // Día bloqueado o no
  festiveType?: string;
  workingDay: string;
  commentShown?: boolean;
}
